import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import NoIndex from "../components/NoIndex";
import CustomerSettlementCard from "../components/rental-lifecycle/CustomerSettlementCard";
import { api } from "../lib/api";

// Task 7: the renter's own page for what happens after the rental.
//
// It needs its own route because the booking confirmation page deliberately
// refuses a link once the booking is finished — and finished is exactly when a
// damage assessment, a proposed deduction or a late toll arrives. The link
// still has to have been issued to this booking and never revoked, and it
// stops working once the settlement window closes.
export default function RentalSettlement() {
  const { token } = useParams();
  const [state, setState] = useState("loading");
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    api.get(`/public/confirm/${token}/rental-summary`)
      .then((r) => { setSummary(r.data); setState("ok"); })
      .catch(() => setState("inactive"));
  }, [token]);

  if (state === "loading") {
    return <div className="p-6 text-slate-500" data-testid="rental-settlement-loading">Loading…</div>;
  }
  if (state === "inactive") {
    return (
      <div className="mx-auto max-w-2xl p-6" data-testid="rental-settlement-inactive">
        <NoIndex />
        <h1 className="text-lg font-semibold">This link is no longer active</h1>
        <p className="mt-2 text-sm text-slate-700">
          Please contact the rental business for the latest details of your rental.
        </p>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-2xl space-y-4 p-4 sm:p-6" data-testid="rental-settlement-page">
      <NoIndex />
      <header>
        <h1 className="text-lg font-semibold">Your rental account</h1>
        <p className="text-sm text-slate-600">
          {summary.business_name} · Booking {summary.booking_reference}
        </p>
      </header>
      <CustomerSettlementCard basePath={`/public/confirm/${token}/rental-settlement`} />
      <section className="rounded-2xl border border-slate-200 bg-white p-5 text-sm space-y-1"
               data-testid="rental-settlement-summary">
        <h2 className="font-semibold">{summary.title}</h2>
        <p>Rental charges: {summary.rental_charges.total_text}</p>
        <p>Additional charges: {summary.additional_charges.total_text}</p>
        <p>Advance payment recorded: {summary.advance_payment.received_text}</p>
        <p>Security deposit recorded: {summary.security_deposit.received_text}</p>
        <p>Applied from your deposit: {summary.security_deposit.applied_text}</p>
        <p>Refunded: {summary.security_deposit.refunded_text}</p>
        <p>Still held: {summary.security_deposit.still_held_text}</p>
        {summary.balance.disputed_centavos > 0 && (
          <p>Disputed and not treated as due: {summary.balance.disputed_text}</p>
        )}
        <p>Still outstanding: {summary.balance.undisputed_outstanding_text}</p>
        <p className="pt-2 text-xs text-slate-500">{summary.not_an_invoice}</p>
        <p className="text-xs text-slate-500">{summary.recorded_language}</p>
      </section>
    </div>
  );
}
